const prefix = 'COMPANIES/';

const COMPANY_TAG = `${prefix}COMPANY`;
export const COMPANY_PERMISSION_TAG = `${prefix}COMPANY_PERMISSIONS`;
export const COMPANIES_LIST_TAG = `${prefix}COMPANIES_LIST`;
export const COMPANY_USER = `${prefix}COMPANY_USER`;

export default COMPANY_TAG;
